/**
 * After Sales Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * DTO represent logistics provider account information
 */
export interface LogisticsProviderAccountDTO { 
    /**
     * ID (primary key)
     */
    id?: number;
    /**
     * Provider code (eg. VTP, SPX, GHN)
     */
    providerCode?: LogisticsProviderAccountDTO.ProviderCodeEnum;
    /**
     * Provider name (eg. Viettel Post, Shopee Xpress)
     */
    providerName?: string;
    /**
     * Provider type (INTERNAL | EXTERNAL)
     */
    providerType?: LogisticsProviderAccountDTO.ProviderTypeEnum;
    /**
     * Account code (eg. VTP-001, SPX-A)
     */
    code?: string;
    /**
     * Account name (eg, Viettel Post 001, Shopee Xpress A)
     */
    name?: string;
    /**
     * Description, notes, remarks
     */
    description?: string;
    /**
     * Active status (ACTIVE | INACTIVE)
     */
    status?: string;
    /**
     * Whether be the default account of the provider
     */
    isDefault?: boolean;
    /**
     * Credentials exclude sensible information such as password, secret,...
     */
    credentials?: { [key: string]: object; };
    /**
     * Webhook secret used to verify callback signature
     */
    webhookSecret?: string;
    /**
     * Account metadata (eg. User ID, email, phone,...)
     */
    metadata?: { [key: string]: object; };
    /**
     * Account config (eg. Default shop ID,...)
     */
    config?: { [key: string]: object; };
}
export namespace LogisticsProviderAccountDTO {
    export const ProviderCodeEnum = {
        Vtp: 'VTP',
        Ghn: 'GHN'
    } as const;
    export type ProviderCodeEnum = typeof ProviderCodeEnum[keyof typeof ProviderCodeEnum];
    export const ProviderTypeEnum = {
        External: 'EXTERNAL',
        Internal: 'INTERNAL'
    } as const;
    export type ProviderTypeEnum = typeof ProviderTypeEnum[keyof typeof ProviderTypeEnum];
}


